import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { RedocStandalone } from 'redoc';

ReactDOM.render(
  <React.StrictMode>
        <RedocStandalone specUrl="https://s3.amazonaws.com/docs.walletfi.com/SubscriptionManagerDocs.json"
            options={
              {hideDownloadButton:true,
              theme:{
                colors:{
                  primary:{
                    main:'#41bfef'}
                  },
                typography:{
                  code:{
                    color:'#41bfef'}
                  }
                }
              }
            }/>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
